import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CfetBaseComponent, CfetPageNamesConstant } from '../../cfet-core';
@Component({
    selector: 'app-complete-profile',
    templateUrl: './complete-profile.component.html',
    styleUrls: ['./complete-profile.component.scss'],
    standalone: false
})
export class CompleteProfileComponent extends CfetBaseComponent implements OnInit {

  constructor(private title: Title) { super(); }

  ngOnInit () {
    this.title.setTitle(CfetPageNamesConstant.COMPLETE_PROFILE_CONFIRMATION);
  }

}
